import { useEffect, useState } from "react"
import getRanges from "../utils/getRanges"

const useProgress = (footerHeight: number, maxTriangles: number = 24) => {
  const [triangles, setTriangles] = useState(0)

  useEffect(() => {
    const updateScrollCompletion = () => {
      const currentProgress = window.scrollY
      const ranges = getRanges(maxTriangles, footerHeight)
      for (let i = 0; i < ranges.length; i++) {
        if (
          currentProgress >= ranges[i].start &&
          currentProgress < ranges[i].end
        ) {
          setTriangles(i)
          break
        }
      }
    }

    window.addEventListener("scroll", updateScrollCompletion)

    return () => {
      window.removeEventListener("scroll", updateScrollCompletion)
    }
  }, [footerHeight])

  return triangles
}

export default useProgress
